import axios from "axios";

// Create an axios instance with the default headers
const api = axios.create({
  // baseURL: "http://192.168.29.242/projects/schoolErp/",
  // baseURL: "https://api.sarvajna.co.in/erp/",

  //  baseURL : "https://sarvajna.onezo.in/api/"
  baseURL: "https://api.diamond-group.org/erp/"


});

export default api;
